<template>
    <span>
    </span>
</template>

<style lang="less">
    .lp-viewport.default-style {
        /* #General Styles ================================================== */
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            list-style: none;
        }
        * {
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        }
        html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, font, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, select, input, option {
            margin: 0;
            padding: 0;
            border: 0;
            outline: 0;
        }
        html {
            -webkit-text-size-adjust: none;
        }
        article, aside, details, figcaption, figure, footer, header, hgroup, nav, section, summary {
            display: block;
        }
        audio, canvas, video {
            display: inline-block;
        }
        audio:not([controls]) {
            display: none;
            height: 0;
        }
        pre {
            white-space: pre;
            white-space: pre-wrap;
            word-wrap: break-word
        }
        q {
            quotes: none
        }
        q:before, q:after {
            content: '';
            content: none
        }
        small {
            font-size: 80%
        }
        sub, sup {
            font-size: 75%;
            line-height: 0;
            position: relative;
            vertical-align: baseline
        }
        sup {
            top: -0.5em;
        }
        sub {
            bottom: -0.25em
        }
        nav ul, nav ol {
            list-style: none;
            list-style-image: none;
        }
        button, input, select, textarea {
            font-size: 100%;
            margin: 0;
            vertical-align: baseline;
            box-shadow: none;
            -webkit-appearance: none !important;
        }
        textarea {
            overflow: auto;
            vertical-align: top
        }
        table {
            border-collapse: collapse;
            border-spacing: 0
        }
        input[type="button"], input[type="submit"] {
            -webkit-appearance: none !important;
        }
        :focus {
            outline: 0;
        }
        ol, ul {
            list-style: none;
        }
        table {
            border-collapse: separate;
            border-spacing: 0;
        }
        caption, th, td {
            text-align: left;
            font-weight: normal;
        }
        a {
            text-decoration: none;
        }
        blockquote:before, blockquote:after, q:before, q:after {
            content: "";
        }
        blockquote, q {
            quotes: "" "";
        }
        table {
            border: 0 none;
            border-collapse: collapse;
            border-spacing: 0;
        }
        td {
            vertical-align: top;
        }
        img {
            border: 0 none;
            max-width: 100%;
            vertical-align: top;
        }
        a {
            outline: none;
            cursor: pointer;
        }
        a:hover {
            text-decoration: none;
        }
        a:focus {
            text-decoration: none !important;
            outline: none !important;
        }
        .none {
            display: none;
        }
        article, aside, details, figcaption, figure, footer, header, hgroup, nav, section {
            display: block
        }
        .clear {
            clear: both;
        }
        img {
            max-width: 100%;
        }
        .cf:before, .cf:after {
            content: "";
            display: table
        }
        .cf:after {
            clear: both;
        }
        .cf {
            *zoom: 1;
        }
        .text-transform {
            text-transform: uppercase;
        }
        .transition-hover {
            transition: 0.5s;
            -webkit-transition: 0.5s;
            -moz-transition: 0.5s;
            -o-transition: 0.5s;
        }
        .break {
            float: left;
            width: 100%;
        }
        img {
            vertical-align: bottom;
        }
        /*Placeholder opacity cross browsers*/
        input::-webkit-input-placeholder {
            color: #646464;
            opacity: 1;
        }
        /* WebKit browsers */
        input:-moz-placeholder {
            color: #646464;
            opacity: 1;
        }
        /* Mozilla Firefox 4 to 18 */
        input::-moz-placeholder {
            color: #646464;
            opacity: 1;
        }
        /* Mozilla Firefox 19+ */
        input:-ms-input-placeholder {
            color: #646464;
            opacity: 1;
        }
        /* Internet Explorer 10+ */
        textarea::-webkit-input-placeholder {
            color: #646464;
            opacity: 1;
        }
        /* WebKit browsers */
        textarea:-moz-placeholder {
            color: #646464;
            opacity: 1;
        }
        /* Mozilla Firefox 4 to 18 */
        textarea::-moz-placeholder {
            color: #646464;
            opacity: 1;
        }
        /* Mozilla Firefox 19+ */
        textarea:-ms-input-placeholder {
            color: #646464;
            opacity: 1;
        }
        /* Internet Explorer 10+ */
        button::-moz-focus-inner, input[type="submit"]::-moz-focus-inner {
            border: 0;
        }

        /* #Page Structure
        ================================================== */
        body { margin: 0; padding: 0; font-size: 26px; color: #605f64; background: #fff; font-family: 'Open Sans', sans-serif; }
        .wrapper { width: 100%; transition: 0.5s; -webkit-transition: 0.5s; -moz-transition: 0.5s; -o-transition: 0.5s; opacity: 0; }
        .main {width: 1170px;margin: 0 auto;}
        a, .btn { transition: 0.5s; -webkit-transition: 0.5s; -moz-transition: 0.5s; -o-transition: 0.5s; }
        .btn { font-weight:600; background-color: #0156a7; color: #fff; font-family: 'Open Sans', sans-serif; ; font-size: 18px; line-height: 18px; ; display: inline-block; vertical-align: top; padding: 16px; max-width: 200px; width: 100%; }
        .btn:hover { background-color: #000; }
        .btn2 { font-weight:600;background-color: #ffffff; color: #000000; font-size: 18px; line-height: 18px; ; display: inline-block; vertical-align: top; padding: 16px; max-width: 242px; text-align: center; width: 100%; }
        .btn2:hover { background-color: #000; color: #fff; }
        h2 { font-size: 32px; line-height: 40px; text-transform: uppercase; }
        h5 { font-size: 24px; line-height: 30px; }

        /***** header styles goes here *****/
        header {
            float: left;
            width: 100%;
            padding: 20px 0 13px;
            position: fixed;
            top: 0px;
            left: 0px;
            z-index: 999;
        }
        header .left-header {
            float: left;
            margin-top: -12px;
            padding-left: 0;
        }
        header .left-header .logo {
            max-width: 237px;
            float: left;
            margin-top: 11px;
        }
        header .left-header .logo a img {
            width: 146px;
            max-width: 100%;
        }
        header .right-header {
            float: right;
            max-width: 324px;
            margin-top: 19px;
            text-align: right;
        }
        header .right-header .job-btn {
            display: inline-block;
            vertical-align: top;
        }
        header .right-header .job-btn a {
            font-weight: 700;
            border-radius: 8px;
            color: #fff;
            float: right;
            font-size: 22px;;
            padding: 10px 35px;
            text-transform: uppercase;
            transition: 0.5s;
            -webkit-transition: 0.5s;
            -moz-transition: 0.5s;
            -o-transition: 0.5s;
        }
        header .right-header .job-btn a:hover {
            background-color: #000;
        }
        header .right-header .call-btn {
            display: inline-block;
            vertical-align: top;
            padding-top: 9px;
        }
        header .right-header .call-btn span {
            color: #000;
            font-size: 25px;;
            float: right;
        }
        header .right-header .call-btn span a {
            font-weight: 400;
            color: #000;
        }
        header .right-header .call-btn span img {
            position: relative;
            top: -5px;
            width: 15px;
            max-width: 100%;
        }
        .header-section {
            float: left;
            width: 100%;
        }
        /***** header styles end*****/

        /***** midd container styles goes here *****/
        .midd-container {
            width: 100%;
            float: left;
            margin: 158px 0 0 0;
        }
        .midd-container .banner {
            width: 100%;
            float: left;
            position: relative;
            padding: 97px 0 110px;
        }
        .info-section-1 {
            float: left;
            width: 100%;
            position: relative;
        }
        .info-section-1 .info-section-left {
            float: left;
            width: 59%;
        }
        .info-section-1 .info-section-left h1 {
            color: #000000;
            font-size: 53px;
            line-height: 60px;
            font-weight: 300;
            text-transform: uppercase;
            font-family: 'HelveticaNeueLT-ExtBlackCond';
            filter: glow(color=white, strength=1);
            text-shadow: -2px -2px 0 #fff,2px -2px 0 #fff, -1px 2px 0 #fff, 2px 2px 0 #fff;
        }
        .info-section-1 .info-section-left h1 span {
            color: #fff;
            font-size: 55px;
            display: block;
            line-height: 84px;
            filter: glow(color=black, strength=1);
            text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
        }
        .info-section-1 .form-area {
            float: right;
            width: 37.65%;
            text-align: center;
        }
        .info-section-1 .form-area h2 {
            color: #10a6c2;
            font-size: 60px;
        }
        .info-section-1 .form-area .form-main {
            background: rgba(0, 0, 0, 0.6);
            border: none;
            float: left;
            margin-top: 3px;
            padding: 11px 37px 18px;
            width: 100%;
        }
        .info-section-1 .form-area .form-main p {
            color: #fff;
            font-size: 18px;
            line-height: 24px;
            font-family: 'Open Sans', sans-serif;
            font-weight: 400;
        }
        .info-section-1 .form-area .form-main .required-details {
            font-weight: bold;
            color: #fff;
            font-size: 28px;
            padding-bottom: 9px;
            padding-top: 8px;
        }
        .info-section-1 .form-area .input-main {
            float: left;
            width: 100%;
            padding-bottom: 10px;
        }
        .info-section-1 .form-area .inputbox {
            float: left;
            width: 100%;
            border: 1px solid #fff;
            border-radius: 0;
            color: #000000;
            font-family: 'Open Sans', sans-serif;
            font-weight: 400;
            font-size: 14px;
            padding: 9px 14px;
            transition: 0.5s;
            -webkit-transition: 0.5s;
            -moz-transition: 0.5s;
            -o-transition: 0.5s;
        }
        .info-section-1 .form-area .inputbox:focus {
            border-color: #e5801c;
        }
        .form-area .sbHolder {
            position: relative;
            float: left;
            width: 100% !important;
        }
        .form-area .sbHolder .sbSelector {
            background: #fff;
            padding: 9px 30px 13px 16px;
            font-size: 14px;
            color: #676767;
            font-family: 'Open Sans', sans-serif;
            font-weight: 400;
            height: 40px;
            cursor: pointer;
            transition: 0.5s;
            -webkit-transition: 0.5s;
            -moz-transition: 0.5s;
            -o-transition: 0.5s;
            display: inline-block;
            width: 100%;
            border: 1px solid #dee6e6;
            border-radius: 0;
            text-align: left;
        }
        .form-area .sbHolder .sbSelector a {
            color: #000;
            font-family: 'Open Sans', sans-serif;
            font-weight: 400;
        }
        .form-area .sbHolder .sbToggle {
            background: url(/images/dlp/arrow-bg.png) no-repeat center top;
            width: 16px;
            height: 11px;
            position: absolute;
            right: 14px;
            top: 50%;
            margin-top: -3px;
            cursor: pointer;
            background-size: 16px;
        }
        .form-area .sbHolder ul {
            margin: 0px;
            padding: 0px 10px 10px 19px;
            list-style: none;
            position: absolute;
            left: 0;
            top: 0;
            width: 100.1% !important;
            background: #eeeeee;
            z-index: 99;
            transform: translateY(-5px);
            -moz-transform: translateY(-5px);
            -webkit-transform: translateY(-5px);
            text-align: left;
            border-radius: 0 0 3px 3px;
            overflow: auto;
        }
        .form-area .sbHolder ul li {
            display: block;
            width: 100%;
        }
        .form-area .sbHolder ul li a {
            color: #000;
            padding: 4px 0px;
            font-size: 14px;
            width: 100%;
            transition: 0.5s;
            -webkit-transition: 0.5s;
            -moz-transition: 0.5s;
            -o-transition: 0.5s;
            font-family: 'Open Sans', sans-serif;
            font-weight: 400;
        }
        .form-area .sbHolder ul li a:hover {
            color: #2163AF;
        }
        .form-area .sbHolder.focused .sbSelector {
            color: #e5801c;
        }
        .form-area .g-recaptcha {
            float: left;
            width: 100%;
            padding-bottom: 8px;
        }
        .submit-area {
            float: left;
            width: 100%;
            margin-top: 7px;
        }
        .submit-area .submit-btn {
            font-weight: bold;
            width: 100%;
            max-width: 280px;
            border-radius: 0;
            text-transform: capitalize;
            color: #fff;
            font-size: 20px;
            padding: 11px;
            font-family: 'Open Sans', sans-serif;
            cursor: pointer;
            transition: 0.5s;
            -webkit-transition: 0.5s;
            -moz-transition: 0.5s;
            -o-transition: 0.5s;
            position: relative;
            background-size: 12px;
            background-repeat: no-repeat;
            background-position: 91% 17px;
        }
        .submit-area .submit-btn:hover, .submit-area .submit-btn:focus {
            background: #fff;
            background-size: 12px;
            background-repeat: no-repeat;
            background-position: 91% 17px;
        }
        .form-area #lead-distribution-validation ul li {
            font-size: 14px;
            text-align: left;
            padding-bottom: 5px;
            font-family: 'Open Sans', sans-serif;
            font-weight: 400;
        }
        .form-area #lead-distribution-validation {
            font-size: 0px;
            color: #fff;
            float: left;
            width: 100%;
        }
        .form-area #lead-distribution-validation ul {
            font-size: 18px;
            color: #fff;
            float: left;
            width: 100%;
            padding: 10px;
            margin-bottom: 10px;
        }
        .form-area label {
            float: left;
            width: 100%;
            font-size: 14px;
            color: #fff;
            text-align: left;
            padding-bottom: 3px;
        }
        .form-moreinfo {
            float: left;
            width: 100%;
            background-color: rgba(0, 0, 0, 0.6);
            padding: 28px 0 10px;
        }
        .form-moreinfo .form-row {
            float: left;
            width: 100%;
            margin: 0 0 5px;
        }
        .form-moreinfo .form-row:last-child {
            margin: -18px 0 0;
        }
        .form-moreinfo .form-row ul {
            display: inline-block;
            width: 100%;
            z-index: 0;
        }
        .form-moreinfo .form-row p {
            font-size: 20px;
            line-height: 22px;
            z-index: 1;
            position: relative;
        }
        .form-moreinfo .form-row a {
            color: #fff;
            font-family: 'Open Sans', sans-serif;
            font-weight: 400;
        }
        .form-moreinfo .form-row ul li {
            display: inline-block;
            vertical-align: bottom;
            font-size: 14px;
            line-height: 18px;
            position: relative;
            padding-right: 10px;
            margin-right: 3px;
        }
        .form-moreinfo .form-row ul li:last-child::before {
            position: absolute;
            left: -10px;
            top: 2px;
            width: 1px;
            height: 14px;
            background-color: #fff;
            content: "";
        }
        .form-moreinfo .form-row a:hover {
            font-family: 'Open Sans', sans-serif;
            font-weight: 400;
        }
        .form-moreinfo .form-row span {
            font-weight: bold;
            color: #fff;
        }

        /***** midd container styles end *****/
        .info-section {
            float: left;
            width: 100%;
            background-color: #f3f3f3;
            padding: 67px 0;
        }
        .info-section p {
            float: none !important;
            font-size: 22px;
            line-height: 31px;
            color: #646464;
            font-family: 'Open Sans', sans-serif;
            font-weight: 400;
            margin-top: 30px;
            width: 100%;
        }
        .info-section p span {
            font-weight: 700;
            color: #000000;
            font-family: 'Open Sans', sans-serif;;
        }
        .info-section a {
            margin: 20px 0 0 0;
        }
        .heading-area {
            float: left;
            width: 100%;
            text-align: left;
            padding-left: 50px;
        }
        .heading-area h2 {
            font-weight: 700;
            color: #000;
            max-width: 100%;
            display: inline-block;
            width: 100%;
            text-align: center;
            font-family: 'Open Sans', sans-serif;;
            font-size: 32px;
        }
        .info-section .heading-area h2 {
            font-size: 40px;
        }
        .info-section .heading-area {
            padding-left: 0px;
        }
         .heading-area h2 {
            text-align: left;
        }
         .list-area-cover {
            width: 100%;
        }
         .list-area-cover .list-area-info {
            float: left;
            width: 100%;
            padding: 13px 408px 32px 50px;
            position: relative;
            min-height: 290px;
            font-size: 22px;
            font-weight: 400;
            line-height: 28px;
        }
         .list-area-cover .list-area-info ul li {
            /*background: rgba(0, 0, 0, 0) url("/images/dlp/arror-right.png") no-repeat scroll left 7px;*/
            color: #646464;
            font-size: 22px;
            font-weight: 400;
            line-height: 28px;
            margin-bottom: 12px;
            padding: 0;
            position: relative;
        }
         .list-area-cover .list-area-info .list-area-image {
            position: absolute;
            right: 54px;
            top: -16px;
            width: 300px; /*overflow: hidden;*/
            margin-top: 30px;
        }
         .list-area-cover .list-area-info .list-area-image img {
            border-radius: 20px;
        }
         .list-area-cover .list-area-info ul li:last-child {
            margin-bottom: 0;
        }
         .list-area-cover .list-area-info.list-area-info1 ul li {
            padding-left: 40px;
            margin-bottom: 18px;
            background-position: left 1px;
            background-image: url("/images/dlp/arror-right.png");
            background-repeat: no-repeat;
            color: #444444;
            font-size: 22px;
            line-height: 22px;
            text-align: left;
            text-transform: none;
            font-family: 'Open Sans', sans-serif;
            font-weight: 400;
        }
        .apply-area {
            border-radius: 8px;
            float: left;
            padding: 31px 50px 33px;
            width: 100%;
        }
        .apply-area .apply-area-info {
            float: left;
            width: 79%;
        }
        .apply-area .apply-area-info:last-child {
            float: right;
            width: 21%;
            text-align: right;
            padding-top: 0px;
        }
        .apply-area .apply-area-info:last-child .btn2 {
            margin: 0;
            border-radius: 4px;
            font-weight: 700;
        }
        .apply-area .apply-area-info p {
            color: #ffffff;
            font-size: 28px;
            font-weight: 400;
            line-height: 37px;
            max-width: 100%;
        }
        .apply-area .apply-area-info p a {
            font-weight: 700;
            color: #fff;
            font-weight: 700;
        }
        .apply-area .apply-area-info p a:hover {
            color: #000;
        }
        .map-area {
            float: left;
            width: 100%;
            text-align: center;
        }
        .map-area .map-cover {
            float: left;
            width: 100%;
            margin: 76px 0 35px;
            position: relative;
        }
        .map-area .map-cover .map-info {
            position: absolute;
            left: 0px;
            top: -20px;
            width: 100%;
            margin-top: -32px;
        }
        .map-area .map-cover .map-info p {
            font-weight: 700;
            font-size: 32px;
            line-height: 35px;
            text-transform: uppercase;;
            display: inline-block;
            background-color: rgba(255, 255, 255, 0.5);
            padding: 0 10px;
        }

         ul {
            margin-left: 37px;
        }

        /***** footer styles goes here *****/
        footer {
            float: left;
            width: 100%;
            padding: 40px 0;
        }
        footer .footer-info {
            width: 30.8%;
            float: left;
        }
        footer .footer-info:nth-child(2) {
            width: 30.2%;
        }
        footer .footer-info:last-child {
            float: right;
            width: 26.3%;
        }
        footer .footer-info .logo {
            max-width: 200px;
        }
        footer .footer-info .logo a img {
            max-width: 100%;
            width: 115px;
        }
        footer .footer-info h5 {
            padding-bottom: 12px;
        }
        footer .footer-info h5 a {
            font-weight: 600;
            color: #000;
            font-size: 14px;
            text-align: left;;
            text-decoration: underline;
        }
        footer .footer-info ul {
            margin: 12px 0 0 0;
        }
        footer .footer-info ul li a {
            color: #000000;
        }
        footer .footer-info ul li {
            line-height: 32px;
            font-size: 18px;
        }
        footer .footer-info p {
            font-size: 16px;
            line-height: 20px;
            font-weight: 400;
            margin: 0 0 12px 0;
            color: #000;
        }
        footer .footer-info .copy {
            float: left;
            width: 100%;
        }
        /***** footer styles end *****/

        .alt-color:nth-child(even) {
            background: white;
        }

        .alt-color-rev:nth-child(odd) {
            background: white;
        }

        header {
            border-bottom: 8px solid white;
        }
        .map-area {
            border-bottom: 5px solid white;
        }

        .midd-container .banner {
            background-position: center top;
            background-size: cover;
        }
    }
</style>

<style lang="less">
    .lp-viewport.default-style {

        /* #Media Queries
        ================================================== */
        &[max-width~="1230px"] {
            .main { width: 100%; padding: 0 20px; }
            header .left-header { padding-left: 0px; }
            .midd-container .banner { padding: 50px 0; }
            .info-section { padding: 70px 0; }
            .info-section p { font-size: 20px; line-height: 30px; padding: 0px; }
            .info-section .main h2, .info-section .main h3 { padding: 0; }
             .list-area-cover .list-area-info { padding: 27px 408px 32px 0px; }
            .heading-area { padding-left: 0; }
             .list-area-cover .list-area-info { font-size: 19px; }
            .apply-area { padding: 30px; margin: 20px 0 0; }
            .apply-area .apply-area-info p { font-size: 26px; line-height: 50px; }
            footer { padding: 30px 0 20px; }
            header .left-header { padding-left: 0; }
            .apply-area .apply-area-info:last-child { padding-top: 25px; }
            .btn2 { font-size: 16px; }
            .info-section-1 .info-section-left h1 { font-size: 48px; line-height: 50px; }
            .info-section-1 .info-section-left h1 span { font-size: 48px; line-height: 45px; margin-top: 5px; margin-bottom: 5px; }
            .list-area-3  .heading-area h2 { max-width: 613px; }
            .list-area-3  .list-area-cover .list-area-info.list-area-info1 ul li { font-size: 19px; }
            .midd-container .banner { background-position: center top; }
            footer .footer-info:last-child { width: 33.3%; }
        }
        &[max-width~="1180px"] {
            .info-section-1 .form-area { width: 40%; }
            .list-area-2  .list-area-info.list-area-info1.list-area-info2, .list-area-2  .list-area-info.list-area-info1.list-area-info2:last-child { padding-bottom: 0; min-height: inherit !important; width: 100%; }
            .apply-area .apply-area-info p { font-size: 24px; }
        }
        &[max-width~="1024px"] {
             .list-area-cover .list-area-info { padding: 27px 280px 32px 0px; }
             .list-area-cover .list-area-info { font-size: 16px; background-position: left 7px; line-height: 21px; }
             .list-area-cover .list-area-info { min-height: 210px; }
            h2 { font-size: 30px; }
            h3 { font-size: 28px; line-height: 30px; }
            .apply-area .apply-area-info p { font-size: 24px; line-height: 58px; }
            .apply-area .apply-area-info:last-child .btn2 { margin: 5px 0 0 0; font-size: 15px; }
            h5 { font-size: 20px; line-height: 25px; }
            footer .footer-info .copy { margin: 0; }
             .list-area-cover .list-area-info ul li { margin-bottom: 10px; }
            .list-area-3  .list-area-cover .list-area-info.list-area-info1 ul li { font-size: 16px; line-height: 21px; }
            .list-area-3.list-area-4  .list-area-cover .list-area-info .list-area-image img { margin-top: 50px; }
            .info-section p { margin-top: 20px; }
             .list-area-cover .list-area-info ul li { background-position: left 6px; background-size: 15px auto; padding-left: 30px; }
            .info-section p { font-size: 18px; line-height: 27px; margin-top: 14px; }
        }
        &[max-width~="999px"] {
            .apply-area .apply-area-info { width: 100%; text-align: center; }
            .apply-area .apply-area-info:last-child { margin: 10px 0 0; padding: 0; text-align: center; width: 100%; }
            .apply-area .apply-area-info p { line-height: 34px; margin-bottom: 5px; }
             .list-area-cover .list-area-info { padding: 15px 280px 0px 0; }
             .list-area-cover .list-area-info .list-area-image { margin-top: 0px; }
            .home-time-section .heading-area p { font-size: 18px; line-height: 24px; }
            .info-section .heading-area h2 { font-size: 36px; }
        }
        &[max-width~="950px"] {
            .info-section-1 .form-area h2 { font-size: 43px; }
            .info-section-1 .form-area .form-main p { font-size: 13px; line-height: 19px; }
            .form-area #lead-distribution-validation ul li { font-size: 13px; }
            .info-section-1 .info-section-left { width: 100%; max-width: 100%; text-align: center; }
            .info-section-1 .info-section-left h1 span { display: block; position: relative; left: -4px; }
            .midd-container .banner { padding: 30px 0; }
            .info-section-1 .info-section-left { padding: 0px 0 20px; }
            .info-section-1 .form-area { float: none; display: inline-block; vertical-align: top; }
            .info-section-1 { text-align: center; }
            .info-section-1 .form-area { width: 100%; max-width: 500px; }
            .apply-area .apply-area-info p { text-align: center; max-width: 100%; padding-top: 0; font-size: 20px; line-height: 26px; }
             .list-area-cover .list-area-info ul li { margin-bottom: 10px; }
             .list-area-cover .list-area-info .list-area-image { right: 35px; }
            .info-section-1 .info-section-left h1 { font-size: 50px; line-height: 55px; }
            .info-section-1 .info-section-left h1 span { font-size: 50px; }
            .info-section { padding: 50px 0; }
            .list-area-3  .list-area-cover .list-area-info { padding: 17px 280px 0px 0; }
            footer .footer-info:last-child { width: 45%; }
             .list-area-cover .list-area-info ul li br { display: none; }
        }
        &[max-width~="800px"] {
            .info-section p br { display: none; }
        }
        &[max-width~="767px"] {
            .info-section .heading-area h2 { font-size: 32px; }
            header { padding: 20px 0px 15px; }
            .midd-container { margin-top: 132px;}
            .info-section-1 .info-section-left { width: 100%; text-align: center; padding-top: 0; }
            .info-section-1 .form-area .form-main { width: 500px; margin: 0 auto; float: none; display: inline-block; }
            .form-area .sbHolder ul { max-height: 255px !important; }
            .form-area .sbHolder ul { padding-right: 14px; }
            header .left-header { padding-left: 0px; margin-top: 0; }
            header .right-header .job-btn a { font-size: 15px; }
            header .right-header .call-btn span { font-size: 18px; }
            header .left-header .logo { margin-top: 0px; max-width: 200px; }
            .info-section-1 .info-section-left h1 { font-size: 40px; line-height: 40px; }
            .info-section-1 .info-section-left h1 span { font-size: 40px; line-height: 30px; padding-top: 10px; padding-bottom: 10px; }
            .info-section-1 .form-area .form-main .required-details { font-size: 20px; line-height: 24px; }
            .submit-area .submit-btn { font-size: 16px; line-height: 20px; background-position: 84% 13px; }
            .submit-area .submit-btn:hover, .submit-area .submit-btn:focus { background-position: 84% 13px; }
            .info-section p { font-size: 15px; line-height: 23px; }
            .btn { font-size: 16px; line-height: 16px; padding: 10px 15px; max-width: 150px; }
             .list-area-cover .list-area-info { padding: 0px; }
             .list-area-cover .list-area-info .list-area-image { position: static; display: inline-block; vertical-align: top; margin: 20px 0; }
             .heading-area h2 { text-align: center; }
             .list-area-cover .list-area-info ul li { text-align: left; }
             .list-area-cover { margin: 10px 0 0 0; }
            h2 { font-size: 26px; line-height: 30px; }
            h3 { font-size: 24px; line-height: 28px; }
            .apply-area .apply-area-info p { font-size: 20px; line-height: 25px; }
            .btn2 { font-size: 16px; line-height: 16px; }
            .map-area .map-cover img { max-width: 400px; }
            .map-area .map-cover .map-info p { font-size: 24px; line-height: 30px; }
            .map-area .map-cover .map-info { margin-top: -40px; }
            footer .footer-info { width: 100%; text-align: center; margin-bottom: 30px; }
            footer .footer-info .logo { display: inline-block; vertical-align: top; }
            footer .footer-info:nth-child(2) { width: 45%; }
            footer .footer-info:last-child { width: 45%; }
            .apply-area { padding: 20px;  margin-top: 20px;}
            .btn2 { padding: 11px 15px; }
            .form-moreinfo .form-row ul li { font-size: 12px; line-height: 14px; }
            footer .footer-info ul li { font-size: 14px; line-height: 30px; }
            footer .footer-info p { font-size: 14px; line-height: 20px; margin: 0 0 2px; }
            .submit-area .submit-btn { max-width: 240px; background-position: 87% 17px; background-size: 8px; }
            .submit-area .submit-btn:hover, .submit-area .submit-btn:focus { background-position: 87% 17px; background-size: 8px; }
            .list-area-3  .list-area-cover .list-area-info { font-size: 14px; }
            .form-moreinfo .form-row:last-child { margin-bottom: 0px; }
             .list-area-cover .list-area-info { font-size: 14px; background-position: left 4px; }
            .info-section { padding: 40px 0; }
            .home-time-bg { padding: 20px 0 31px; }
            footer .footer-info:last-child { width: 100%; margin-bottom: 0; }
            .list-area-3  .list-area-cover .list-area-info { font-size: 16px; line-height: 35px; background-position: left 4px; }
            header .right-header .job-btn a { padding: 8px 31px; }
            header .left-header .logo a img { max-width: 100%; width: 116px;}
            header {  padding: 10px 0;}
            .list-area-3  .heading-area h2 { text-align: center; }
            .apply-area .apply-area-info p a { display: block; }
            footer .footer-info { margin-bottom: 20px; }
            .list-area-3.list-area-4  .list-area-cover .list-area-info .list-area-image img { margin-top: 0px; }
            footer .footer-info h5 { padding-bottom: 6px; }
            footer { padding: 25px 0; }
        }
        &[max-width~="640px"] {
            header .left-header .logo { max-width: 160px; }
            header .left-header .logo { margin-top: 0px; }
            .info-section-1 .form-area .form-main { width: 400px; }
            .info-section-1 .form-area .inputbox { padding: 9px 19px; }
            .form-area .sbHolder .sbSelector { padding: 9px 19px; height: 37px; }

            .form-area .sbHolder ul { transform: translateY(-2px); -moz-transform: translateY(-2px); -webkit-transform: translateY(-2px); }
            .form-area .sbHolder { margin-top: -3px; }
            header { padding: 20px 0 14px; }
            .list-area-2  .list-area-cover .list-area-info ul li { font-size: 14px; line-height: 23px; background-position: left 4px; padding: 0 0 0 25px; }
             .list-area-cover .list-area-info { font-size: 14px; text-align: center;}
             .list-area-cover .list-area-info ul li { font-size: 14px; background-position: left 4px; padding: 0 0 0 25px; }
            .map-area .map-cover .map-info p { font-size: 20px; line-height: 28px; }
            footer .footer-info:nth-child(2) { width: 100%; }
            footer .footer-info:last-child { width: 100%; }
            header { text-align: center; }
            footer .footer-info .copy { margin: 8px 0 0 0; }
            footer .footer-info:last-child { margin-bottom: 0px; }
            header .right-header .call-btn { margin: 4px 0 0 0; }
            .info-section-1 .info-section-left h1 { font-size: 38px; line-height: 44px; }
            .info-section-1 .info-section-left h1 span { font-size: 40px }
            header .right-header { margin-top: 12px;}
            header .right-header .job-btn a { padding: 8px 18px; }
            header .right-header .call-btn span, header .right-header .call-btn span a { font-size: 15px; }
            header .right-header .call-btn span img { top: -2px; }
            header .right-header .job-btn a { font-size: 14px; }
            header .left-header .logo a img { max-width: 100%;  width: 100px;}
            header .right-header .call-btn { margin: 0; }
            header .right-header .call-btn span img { width: 12px; }
            .home-time-bg { padding: 20px 0 34px; }
            .list-area-2  .heading-area h2, .list-area-3  .heading-area h2 { font-size: 22px; }
            .heading-area h2 { font-size: 22px; }
            .info-section .heading-area h2 { font-size: 22px; }
            .info-section-1 .form-area { width: 100%; max-width: 400px; }
            li .fa-li { top:.55em;}
        }

        &[max-width~="480px"] {
            .midd-container { margin-top: 90px;}
            header { padding: 5px 0 0}
            header .left-header .logo a img, footer .footer-info .logo a img { margin-top: 0; width: 80px;}
            header .right-header .job-btn a { font-size: 12px;  padding: 8px 16px;}
            header .right-header {  margin-top: 9px; max-width: 170px;}
            header .right-header .call-btn span, header .right-header .call-btn span a {font-size: 13px;}
            header .left-header .logo { max-width: 100%; width: 100%; text-align: center; margin-top: 0; }
            .info-section-2 ul li { width: 100%; }
            .info-section-1 .form-area .form-main { width: 100%; padding-left: 15px; padding-right: 15px; padding-bottom: 22px; }
            .info-section-1 .form-area .form-main p { font-size: 12px; line-height: 17px; }
            .info-section-3 h4 { font-size: 21px; }
            ul.bullets li { font-size: 15px; background-size: 6px; background-position: left 9px; padding-left: 15px; }
            .info-section-4 h5 { font-size: 21px; line-height: 28px; }
            .info-section-4 p { font-size: 14px; }
            .info-section-4 { padding: 21px 0 26px; }
            ul.bullets2 li { font-size: 15px; margin-bottom: 15px; }
            ul.bullets2 li br { display: none; }
            .shape-bg-bottom { bottom: -100px; }
            .info-section-1 .info-section-left h1 { font-size: 30px; line-height: 34px; }
            .info-section-1 .info-section-left h1 span { font-size: 32px; line-height: 30px; }
            h2 { font-size: 20px; line-height: 25px; }
            h3 { font-size: 16px; line-height: 23px; }
            .map-area .map-cover img { max-width: 250px; }
            .submit-area .submit-btn { max-width: 240px; background-position: 88% 17px; background-size: 8px; }
            .submit-area .submit-btn:hover, .submit-area .submit-btn:focus { background-position: 88% 17px; background-size: 8px; }
            footer .footer-info p span { display: block; }
            .list-area-3  .list-area-cover .list-area-info.list-area-info1 ul li { font-size: 16px; line-height: 20px; }
            .home-time-section .heading-area p, .apply-area .apply-area-info p { font-size: 16px; line-height: 20px; }
            header .right-header .call-btn { padding-top: 4px; }
            .heading-area h2 { font-size: 19px; margin-bottom: 7px; }
            .info-section .heading-area h2 { font-size: 18px; }
            .info-section p { margin-top: 7px; line-height: 20px; }
            .info-section { padding: 30px 0px; }
             .list-area-cover .list-area-info .list-area-image { text-align: center; max-width: 100%;  margin: 0px 0px 20px 0px;}
            .list-area-2 { padding: 20px 0px; }
            .list-area-2  .list-area-cover .list-area-info .list-area-image { text-align: center; max-width: 100%;  margin: 0px 0px 20px 0px; }
             .list-area-cover .list-area-info ul li { background-position: left 3px;}
            .list-area-3  { padding: 20px 0px; }
            .list-area-3  .list-area-cover .list-area-info .list-area-image { text-align: center; max-width: 100%;  margin: 0px 0 20px; }
            .list-area-3  .list-area-cover .list-area-info.list-area-info1 ul li { font-size: 14px; }
            .info-section p { font-size: 14px; line-height: 23px; }
            .list-area-2  .heading-area h2, .list-area-3  .heading-area h2 { font-size: 19px; }
        }
        &[max-width~="450px"] {
            .banner-area { height: 420px; }
            header .logo-main img { width: 150px; }
            header .logo-main { padding-top: 12px; }
            .copyright-info p { font-size: 10px; }
        }
        &[max-width~="380px"] {
            header .logo-main { padding-top: 6px; }
            .info-section-1 { padding-top: 0px; }
            .home-time-section .heading-area p { font-size: 14px; line-height: 20px; }
        }
        &[max-width~="340px"] {
            header .logo-main { padding-top: 3px; }
            .info-section-1 .info-section-left h1, .info-section-1 .info-section-left h1 span { font-size: 24px; line-height: 30px; }
        }

    }
</style>

<style lang="less">

    .lp-viewport.default-style {

        .wrapper .info-section .main p {
            float: none !important;
            padding-bottom: 15px;
        }

        .wrapper .info-section .main h1,
        .wrapper .info-section .main h2,
        .wrapper .info-section .main h3,
        .wrapper .info-section .main h4 {
            padding-top: 40px;
        }
    }

</style>

<style lang="less">
    .lp-viewport.default-style {
        header {
            position: inherit;
        }
        .midd-container {
            margin: 0 !important;
        }

        .icon-chevron-circle-right {
            padding: 0 10px;
        }
        .info-section .main ul {
            font-size: 20px;
            line-height: 35px;
            margin-top: 25px;
        }
        .info-section .main ul li {
            padding: 7px 0;
        }

        .info-section .main ul ul{
            margin: 0;
        }
        .info-section .main ul ul li {
            padding: 7px 0 7px 40px;
        }

        &[max-width~="550px"] {
            .info-section .main ul {
                font-size: 15px;
                line-height: 25px;
            }
            .info-section .main ul li {
                padding: 5px 0;
            }
            .info-section .main ul ul li {
                padding: 5px 0 5px 40px;
            }
        }

         .list-area-cover .list-area-info {
            padding-left: 0;
        }

        .heading-area {
            padding-left: 0;
        }

         ul {
            margin-left: 0;
        }
    }
</style>

<style lang="less">
    .lp-viewport.default-style {
        .border-color {
            border-color: #064f86;
        }

        .fg-color {
            color: #064f86;
        }

        .bg-color {
            background-color: #064f86;
        }

        .fg-color-hover:hover {
            color: #064f86;
        }

        .bg-color-hover:hover {
            background-color: #064f86;
        }
    }

    /*.submit-area .submit-btn {*/
        /*background-image: url({{ url("images/dlp/form-arrrow.png") }});*/
    /*}*/
    /*footer { background: url('{{ url("images/dlp/header-bg.jpg") }}') repeat left top;  }*/

/*header {*/
    /*@if ($page->header_style == 'white')*/
    /*background: white;*/
    /*@else*/
    /*background-image: url({{ url("images/dlp/header-bg.jpg") }});*/
    /*background-repeat: no-repeat;*/
    /*background-position: center center;*/
    /*background-size: cover;*/
    /*-webkit-background-size: cover;*/
    /*-moz-background-size: cover;*/
    /*@endif*/
    /*}*/

    /*.midd-container .banner {*/
        /*background-image: url({{ $heroImage }}); background-position: {{ $heroPosition ? $heroPosition : "top left" }}; background-size: cover;*/
    /*}*/
</style>

<script>
    export default {
        props: []
    }
</script>
